import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Params, Router } from '@angular/router';
import { X } from 'angular-feather/icons';
import { forEach } from 'lodash';
import { of } from 'rxjs';

@Component({
  selector: 'app-rich-text-displayer',
  templateUrl: './rich-text-displayer.component.html',
  styleUrls: ['./rich-text-displayer.component.scss']
})
export class RichTextDisplayerComponent {

  @Input() textToDisplay: string | undefined = "";
  @Input() ellipsisCharCount: number | undefined = undefined;

  dataText: string = '';

  trustedHtmlRender: SafeHtml | undefined;

  constructor(
    protected sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textToDisplay']) {
      if(this.textToDisplay === undefined){
        this.textToDisplay = "";
      }
      if(this.ellipsisCharCount !== undefined){
        this.textToDisplay = this.ellipsisText(this.textToDisplay,this.ellipsisCharCount);
      }
      this.trustedHtmlRender = this.sanitizer.bypassSecurityTrustHtml(this.textToDisplay);
    }

  }

  ellipsisText(str: string | undefined, charCount: number): string {
    if (str) {
      if (str.length > (charCount + 3)) {
        return `${str.substring(0, charCount)}...`
      }
      return str;
    }
    return '';
  }

  @HostListener("click", ['$event'])
  onClick(event: MouseEvent) {

    if (event.target instanceof HTMLAnchorElement === false) {
      return;
    }

    event.preventDefault();
    let url = <HTMLAnchorElement>event.target;

    var query: string = url.toString().substring(url.toString().indexOf('?') + 1);
    var params: string[] = query.split('&');

    var queryParamsModel: any = {};
    params.forEach(pair => {
      var key = pair.split('=')[0];
      var value = pair.split('=')[1];

      queryParamsModel = {
        ...queryParamsModel,
        [key]: value
      }
    })

    var documentItem = <HTMLElement>document.getElementsByClassName("modal").item(0);
    if (documentItem) {
      documentItem.remove();
    }

    documentItem = <HTMLElement>document.getElementsByClassName("modal-backdrop").item(0);
    if (documentItem) {
      documentItem.remove();
    }

    documentItem = <HTMLElement>document.getElementsByClassName("modal-open").item(0);
    if (documentItem) {
      documentItem.setAttribute('style', '');
    }

    this.router.navigate([url.pathname], { queryParams: queryParamsModel });
  }
}
